// `__clear` is the router's own flag, not table state: set on a navigation, it tells
// retainSearchParamsWithClear (lib/router.ts) to drop the params it would otherwise carry over,
// and that middleware strips it. Not every route registers the middleware, though -- on the ones
// that don't (Alerts, the job-devices tabs, ...) a top-level `__clear=true` simply stays in the
// URL, harmless there because no table reads an un-prefixed key it did not list. The shared filter
// actions (submit, remove a chip, clear all) hand the flag to setQueryArgument INSIDE the table
// argument, and a table argument is what request bodies are built from: CSV downloads, bulk
// actions, deploys. Under the backend's strict validation every one of those DTOs rejects an
// unknown key, so a flag left in the argument turns the request into a 400 (ID-7067). Anything
// that holds a table argument has to take it back out.
//
// Import-free on purpose: the table context and the search namespaces both need it, and neither
// should have to load the router module for a string.
export const CLEAR_FLAG = "__clear";

// Hands back the value itself when there is no flag, so a memo over the result keeps the same
// object for every table that never carries one.
export function withoutClearFlag<T>(value: T): T {
  if (typeof value !== "object" || value === null || !(CLEAR_FLAG in value)) {
    return value;
  }
  const { [CLEAR_FLAG]: _clear, ...rest } = value as Record<string, unknown>;
  return rest as T;
}
